import { render, staticRenderFns } from "./withdrawalamount.vue?vue&type=template&id=af261b3c&scoped=true"
import script from "./withdrawalamount.vue?vue&type=script&lang=js"
export * from "./withdrawalamount.vue?vue&type=script&lang=js"
import style0 from "./withdrawalamount.vue?vue&type=style&index=0&id=af261b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af261b3c",
  null
  
)

export default component.exports